<template>
  <div class="col-lg-4">
    <div class="termlyPost">
      <div class="noPost" v-if="termlyReportPostListHeader.length < 1">
        <div class="noPostImage">
          <div><img src="../../../assets/notif1.png" /></div>
          <div>
            <strong>{{ lang('No Post Found') }}</strong>
          </div>
        </div>
      </div>
      <div class="p-2" v-if="termlyReportPostListHeader.length > 0">
        <div class="row withPostHeader">
          <div class="col-12 pb-2 mb-3 withPostHeaderTitle text-left border-bottom">
            <i class="material-icons">playlist_add</i><span> {{ lang('Post Lists') }}</span>
          </div>
          <div class="col-lg-12">
            <div>
              <label class="font">{{ lang('Search Title') }}</label>
            </div>
            <div>
              <el-input type="input" v-model="filterPostTitle" @input="filterPost()" class="inputFilterPostTitle"></el-input>
            </div>
          </div>
          <div class="col-lg-4 mt-2">
            <el-select v-model="ddlFilterPostType" placeholder="Select Type" class="pro-edt-select ddlFilterPostType" @change="filterPost()">
              <el-option v-for="item in ddlFilterPostTypeList" :key="item.Selection" :label="lang(item.Selection)" :value="item.Selection"> </el-option>
            </el-select>
          </div>
          <div class="col-lg-4 mt-2">
            <el-select v-model="ddlFilterPostOwner" placeholder="Select Post Owner" class="pro-edt-select ddlFilterPostType" @change="filterPost()">
              <el-option v-for="item in ddlFilterPostOwnerList" :key="item.Name" :label="lang(item.Name)" :value="item.Name"> </el-option>
            </el-select>
          </div>
          <div class="col-lg-4 mt-2">
            <el-select v-model="ddlFilterTerm" placeholder="Select Term" class="pro-edt-select ddlFilterPostType" @change="filterPost()">
              <el-option v-for="item in ddlFilterTermList" :key="item.Term" :label="lang(item.Term)" :value="item.Term"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="withPostContent p-2">
          <div v-if="termlyReportPostListHeaderFilter.length < 1">
            <div>
              <div><img src="../../../assets/notif1.png" /></div>
              <div>
                <strong>{{ lang('No Post Found') }}</strong>
              </div>
            </div>
          </div>
          <div
            class="divEachPostHeader border-bottom py-3"
            v-if="termlyReportPostListHeaderFilter.length > 0"
            v-for="header in termlyReportPostListHeaderFilter"
          >
            <K2Row space-between="true">
              <K2Row justify_content="flex-start" flex_direction="column" align="flex-start" style="max-width: 75%">
                <div class="postTitle" v-html="header.PostTitle" :class="header.show && 'open'"></div>
              </K2Row>
              <div class="postDate ms-2">
                {{ header.PostDate_Convert }}<br />
                <K2Text link="true" @onclick="showPost(header)">Show More</K2Text>
              </div>
            </K2Row>
            <K2Row
              v-for="details in termlyReportPostListDetails.filter(data => data.PostID === header.PostID && data.Active)"
              class="divEachPostDetails px-2 pt-3"
            >
              <div class="row me-2">
                <div class="col-lg-3 eachPostDetailsTitle">Domain</div>
                <div class="col-lg-9 eachPostDetailsContent">{{ details.Domain }}</div>
                <div class="col-lg-3 eachPostDetailsTitle">Goals</div>
                <div class="col-lg-9 eachPostDetailsContent">{{ details.Goals }}</div>
                <div class="col-lg-3 eachPostDetailsTitle">Indicator</div>
                <div class="col-lg-9 eachPostDetailsContent">{{ details.Indicator }}</div>
              </div>
              <div>
                <span class="copyIcon" @click="handleAddToTermlyReport(details)">
                  <i class="material-icons">content_copy</i>
                </span>
              </div>
            </K2Row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lang } from '../../../locale'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Text from '../../../uiComponents/k2Text/k2Text'

export default {
  name: 'TermlyPost',
  components: { K2Text, K2Row },
  props: [
    'passTermlyReportPostListHeader',
    'passTermlyReportPostListHeaderFilter',
    'ddlFilterPostTypeList',
    'ddlFilterPostOwnerList',
    'ddlFilterTermList',
    'termlyReportPostListDetails',
    'addToTermlyReport',
  ],
  watch: {
    passTermlyReportPostListHeaderFilter: function (value) {
      if (value) {
        this.termlyReportPostListHeaderFilter = value
      }
    },
    passTermlyReportPostListHeader: function (value) {
      if (value) {
        this.termlyReportPostListHeader = value
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.termlyReportPostListHeaderFilter = this.passTermlyReportPostListHeaderFilter
    this.termlyReportPostListHeader = this.passTermlyReportPostListHeader
  },
  data() {
    return {
      filterPostTitle: '',
      ddlFilterPostType: '',
      ddlFilterPostOwner: '',
      ddlFilterTerm: '',
      termlyReportPostListHeaderFilter: '',
      termlyReportPostListHeader: '',
    }
  },
  methods: {
    lang,
    handleScroll(event) {
      let header = document.querySelector('.termlyPost')
      if (window.scrollY > 100 && !header.className.includes('sticky-top')) {
        header.classList.add('sticky-top')
      } else if (window.scrollY < 100) {
        header.classList.remove('sticky-top')
      }
    },
    filterPost(val, model) {
      switch (model) {
      }
      //reset all
      this.termlyReportPostListHeaderFilter = this.termlyReportPostListHeader.filter(data => data.Active)
      //reset all

      if (this.ddlFilterPostType !== '') {
        if (this.ddlFilterPostType === 'Moments') {
          this.termlyReportPostListHeaderFilter = this.termlyReportPostListHeader.filter(data => data.Active && data.PostType === 'Portfolio')
        } else if (this.ddlFilterPostType === 'NewsFeed') {
          this.termlyReportPostListHeaderFilter = this.termlyReportPostListHeader.filter(data => data.Active && data.PostType === 'Update')
        }
      }

      if (this.filterPostTitle !== '') {
        this.termlyReportPostListHeaderFilter = this.termlyReportPostListHeaderFilter.filter(
          data => data.Active && data.PostTitle.includes(this.filterPostTitle),
        )
      }

      if (this.ddlFilterPostOwner !== '') {
        this.termlyReportPostListHeaderFilter = this.termlyReportPostListHeaderFilter.filter(
          data => data.Active && data.CreatorName.includes(this.ddlFilterPostOwner),
        )
      }

      if (this.ddlFilterTerm !== '') {
        this.termlyReportPostListHeaderFilter = this.termlyReportPostListHeaderFilter.filter(data => data.Active && data.PostTerm.includes(this.ddlFilterTerm))
      }
    },
    handleAddToTermlyReport(details) {
      this.$emit('addToTermlyReport', details)
    },
    showPost(header) {
      header.show = header.show !== true
      this.$forceUpdate()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../termly';
</style>
